import api, { baseApiService } from "shared/api";
import useSWRImmutable from "swr/immutable";

const availableModulesFetcher = ([url, requestNumber, userRole]) =>
  api
    .post(url, {
      application_number: requestNumber,
      user_role: userRole,
    })
    .then((res) => res.data.data);

export function useAvailableModules({
  requestNumber = null,
  userRole = null,
  triggerRequest = true,
} = {}) {
  return useSWRImmutable(
    triggerRequest
      ? [baseApiService.ENDPOINTS.available_modules, requestNumber, userRole]
      : null,
    availableModulesFetcher
  );
}
